
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiTime as ObiTimeElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-time.js';
 
 
 

 
 export const ObiTime = createComponent({
   react: React,
   tagName: 'obi-time',
   elementClass: ObiTimeElement,
   events: {
     
   }
  });
 
 